
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class RoundIcon extends Vue {
	@Prop() iconClass: string;
}
